var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.51758 39.8335V39.8335C2.51758 34.4951 6.84583 30.1668 12.1842 30.1668H21.8509C27.1893 30.1668 31.5176 34.4951 31.5176 39.8335V39.8335",
    stroke: "#00BAB5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9339 7.57279C37.2713 7.57279 39.9756 10.277 39.9756 13.6145C39.9756 16.9519 37.2713 19.6561 33.9339 19.6561",
    stroke: "#00BAB5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8295 8.40731C26.0392 11.6171 26.0392 16.8211 22.8295 20.0308C19.6197 23.2406 14.4157 23.2406 11.2059 20.0308C7.99618 16.8211 7.99618 11.6171 11.2059 8.40731C14.4157 5.19756 19.6197 5.19756 22.8295 8.40731",
    stroke: "#00BAB5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3513 27.75C41.6897 27.75 46.0179 32.0783 46.0179 37.4167V37.4167",
    stroke: "#00BAB5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageUserIcon);
export default __webpack_public_path__ + "static/media/manage-user-icon.fcd396ad6c1ff092b29273130d385319.svg";
export { ForwardRef as ReactComponent };